import { render, staticRenderFns } from "./createCompanyModal.vue?vue&type=template&id=1d8b7b96&"
import script from "./createCompanyModal.vue?vue&type=script&lang=js&"
export * from "./createCompanyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports